export default "__VITE_ASSET__DdDR3ebg__"